"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.app = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const head_1 = __importDefault(require("next/head"));
const next_seo_1 = require("next-seo");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const fetching_1 = require("../client/fetching");
const constants_1 = require("../constants");
const generated_theme_js_1 = __importDefault(require("../constants/generated.theme.js"));
const lib_1 = require("../lib");
const app_1 = require("../lib/app");
const GlobalStyles_1 = require("../lib/GlobalStyles");
const usePrevPath_1 = require("../lib/hooks/usePrevPath");
const resources_1 = require("../lib/resources");
const theme_1 = require("../theme");
const trackers_1 = require("../trackers");
require("../polyfill");
const renderers = new Map();
const authContextPaths = ['signIn', 'signUp', 'forgotPassword'];
const defaultEnhance = (C) => C;
const defaultContextPaths = {};
function InternalApp({ Component, pageProps, router, enhance = defaultEnhance, contextPaths = defaultContextPaths, globalStoreHook, seoData, }) {
    const clientCache = pageProps[fetching_1.CLIENT_CACHE];
    const resourceLinks = pageProps[resources_1.RESOURCE_LINKS];
    const setPrevPath = (0, usePrevPath_1.useSetPrevPath)();
    const contextValue = (0, react_1.useMemo)(() => ({
        defaultLang: (0, lib_1.getDomainLang)(router.pathname),
        messages: constants_1.APP_MESSAGES,
        cache: clientCache,
        resourceLinks,
        contextPaths,
        globalStoreHook: globalStoreHook !== null && globalStoreHook !== void 0 ? globalStoreHook : (0, lib_1.createStore)({}, {}),
    }), [
        router.pathname,
        clientCache,
        resourceLinks,
        contextPaths,
        globalStoreHook,
    ]);
    if (!renderers.get(Component)) {
        renderers.set(Component, enhance(Component));
    }
    const Render = renderers.get(Component);
    if (process.env.NODE_ENV === 'development') {
        const paths = Object.keys(require.cache || {}).filter((k) => k.includes('constants/generated.theme'));
        paths.forEach((path) => {
            delete require.cache[path];
        });
    }
    const app = ((0, jsx_runtime_1.jsx)(theme_1.CacheProvider, Object.assign({ value: theme_1.cache }, { children: (0, jsx_runtime_1.jsxs)(theme_1.ThemeProvider, Object.assign({ theme: generated_theme_js_1.default }, { children: [(0, jsx_runtime_1.jsx)(Render, Object.assign({}, pageProps)), (0, jsx_runtime_1.jsx)("div", { id: lib_1.GLOBAL_PORTAL_ID }), (0, jsx_runtime_1.jsx)(GlobalStyles_1.GlobalStyles, {})] })) })));
    const lang = (0, lib_1.getLangFromPathname)(router.pathname);
    const messages = lang && constants_1.LOCALES[lang];
    (0, react_1.useEffect)(() => {
        return () => {
            var _a;
            const authPaths = authContextPaths.map((path) => contextPaths[path]);
            const currPath = router._inFlightRoute;
            if (currPath && !authPaths.includes(currPath)) {
                setPrevPath((_a = router._inFlightRoute) !== null && _a !== void 0 ? _a : '/');
            }
        };
    }, [contextPaths, router, router._inFlightRoute, setPrevPath]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(head_1.default, { children: (0, jsx_runtime_1.jsx)("meta", { name: "viewport", content: "width=device-width, initial-scale=1.0" }) }), (0, jsx_runtime_1.jsx)(next_seo_1.DefaultSeo, Object.assign({}, seoData)), (0, jsx_runtime_1.jsx)(lib_1.AppContext.Provider, Object.assign({ value: contextValue }, { children: (0, jsx_runtime_1.jsx)(app_1.AppEffects, Object.assign({ router: router }, { children: (0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, Object.assign({ locale: lang, messages: messages || {} }, { children: app })) })) })), (0, jsx_runtime_1.jsx)(trackers_1.FbMessenger, {})] }));
}
const app = (appProps = {}) => ({ Component, pageProps, router }) => ((0, jsx_runtime_1.jsx)(InternalApp, Object.assign({ Component: Component, pageProps: pageProps, router: router }, appProps)));
exports.app = app;
